.component {
  //border-radius: 4px;

  &:active {
	background-color: rgba(100, 100, 100, 0.1);
  }
}
